import { render, staticRenderFns } from "./UserEditTabPermission.vue?vue&type=template&id=195fbdc5"
import script from "./UserEditTabPermission.vue?vue&type=script&lang=js"
export * from "./UserEditTabPermission.vue?vue&type=script&lang=js"
import style0 from "./UserEditTabPermission.vue?vue&type=style&index=0&id=195fbdc5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports